import { getAxiosInstance } from '../client';
/** Typed API functions for notifications */
export const notificationsQueries = {
    /** GET /users/:userId/notifications */
    getByUser: (userId, params) => getAxiosInstance()
        .get(`/users/${userId}/notifications`, { params })
        .then((r) => r.data),
};
/** Typed API functions for notification counts */
export const notificationCountQueries = {
    /**
     * GET /users/:userId/notifications/count — the size of the Offen lane, which
     * is what the bell badge means since PRD #1453. Not an unread count: reading
     * is a side effect of listing, so "unread" only ever measured how recently the
     * Posteingang was last opened.
     */
    getOpenCount: (userId) => getAxiosInstance()
        .get(`/users/${userId}/notifications/count`)
        .then((r) => r.data),
};
/** Query keys for notifications - use with TanStack Query */
export const notificationsKeys = {
    all: () => ['notifications'],
    byUser: (userId, params) => ['notifications', 'user', userId, params],
    openCount: (userId) => ['notifications', 'user', userId, 'count'],
};
//# sourceMappingURL=notifications.queries.js.map